import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ClusterCommunityStoreActions,
  ClusterCommunityStoreSelectors,
  ClusterCommunityStoreReducer,
} from './index';
import { ClusterCommunityDto } from '@cradua/data';

@Injectable()
export class ClusterCommunityFacade {
  constructor(
    private store: Store<
      ClusterCommunityStoreReducer.ClusterCommunityPartialState
    >
  ) {}

  clusterRecord$ = this.store.select(
    ClusterCommunityStoreSelectors.getSelected
  );
  clusterRecordError$ = this.store.select(
    ClusterCommunityStoreSelectors.getClusterCommunityError
  );

  getselected() {
    return this.store.select(ClusterCommunityStoreSelectors.getSelected);
  }

  get isLoadingClusterCommunity() {
    this.store.dispatch(ClusterCommunityStoreActions.loadClusterCommunity());
    return this.store.select(
      ClusterCommunityStoreSelectors.loadingClusterCommunity
    );
  }

  get loadClusterCommunity() {
    this.store.dispatch(ClusterCommunityStoreActions.loadClusterCommunity());
    return this.store.select(
      ClusterCommunityStoreSelectors.getAllClusterCommunity
    );
  }

  addClusterCommunity(newClusterCommunity: ClusterCommunityDto[]) {
    this.store.dispatch(
      ClusterCommunityStoreActions.addClusterCommunity({ newClusterCommunity })
    );
  }

  updateClusterCommunity(updateClusterCommunity: ClusterCommunityDto[]) {
    this.store.dispatch(
      ClusterCommunityStoreActions.updateClusterCommunity({
        updateClusterCommunity,
      })
    );
  }

  removeClusterCommunity(ids: string[]) {
    this.store.dispatch(
      ClusterCommunityStoreActions.removeClusterCommunity({ ids })
    );
  }
}
